export const UI_MODIFICATIONS_ANALYTICS_CHANNEL = 'ui-modifications';
